
<template>
  <div>
    <v-card color="white lighten-1" class="ma-3">
      <v-card-text>
        <v-form ref="form" :readonly="readonly">
          <v-text-field v-model="vehicle.max_capacity" label="Capacidade Máxima" type="tel" v-mask="'####'"
            suffix="toneladas" prepend-icon="mdi-weight" :rules="[rules.required]"></v-text-field>
          <v-radio-group v-model="vehicle.internal" row>
            <v-radio color="blue" label="Externo" :value="false"></v-radio>
            <v-radio color="red darken-3" label="Interno" :value="true"></v-radio>
          </v-radio-group>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

export default {
  name: 'PropsForm',
  props: {
    vehicle:{
      type: Object,
    },
    readonly:{
      type:Boolean,
      default: false,
    }
  },
  data() {
    return {
      rules: {
        required: v => !!v || 'Campo é necessário',
      },
    }
  },
  methods:{
    validate(){
      return this.$refs.form.validate()
    },
  }
}
</script>